import { FETCH_FAQ } from './constants'

export const fetchFaq = {
  request: (faqId) => ({ type: FETCH_FAQ.REQUEST, faqId }),
  success: (faq) => ({ type: FETCH_FAQ.SUCCESS, faq }),
  failure: (message) => ({ type: FETCH_FAQ.FAILURE, message })
}
